/* tslint:disable */
/* eslint-disable */
export enum NotificationType {
  Success = 'Success',
  Information = 'Information',
  Warning = 'Warning',
  Error = 'Error'
}
